var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hamburger menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.5 17.2746L3.5 16.2746L20.5 16.2746V17.2746L3.5 17.2746ZM3.5 12.4996V11.4996L20.5 11.4996V12.4996L3.5 12.4996ZM3.5 7.72461V6.72461L20.5 6.72461V7.72461L3.5 7.72461Z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuIcon);
export default __webpack_public_path__ + "static/media/hamburger-menu-icon.3a81efdf1dec6fcf29c76b9e82136a87.svg";
export { ForwardRef as ReactComponent };